module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_engl_sekundaerlogo_postale_neg.63fb56e2.pdf";